// extracted by mini-css-extract-plugin
module.exports = {"updateActionButton":"EditSponsor_updateActionButton__1ou0k"};